/* eslint-disable no-unused-vars */
define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'text!readingiq-src/js/riq-js/riq-preload-manager/1.0.0/index.html'
  /* eslint-enable */
], function riqListenerPreloadModule(app, aoflModules, html) {
  'use strict';
  var storeService = aoflModules.store;
  var apiRequest = aoflModules.apiRequest;

  app.registerComponent('riqPreloadManager', {
    require: {},
    bindings: {},
    controller: 'riqPreloadManagerController'
  });
  app.registerController('riqPreloadManagerController', [
    '$rootScope',
    '$scope',
    '$element',
    'compileService',
    function controller($rootScope, $scope, $element, compileService) {
      var _this = this;
      _this.urlArgs = '?build=' + aofljsConfig.buildId;

      compileService.compile({html: html}, $scope, $element);
      $rootScope.$on('$stateChangeSuccess', function onStateChangeSuccess(
        event,
        toState,
        toStateParams,
        fromState,
        fromStateParams
      ) {
        setTimeout(function() {
          requestIdleCallback(function() {
            _this.startPreload = true;
            $scope.$digest();
          });
        }, 10000);
      });
    }
  ]);
});
